module.exports = __webpack_public_path__ + "img/GS.8d052796.svg";